import type { ReactElement } from 'react';

import css from './header.module.scss';

interface Props {
    icon: ReactElement;
    title: string;
    subtitle: string;
    chip: string;
}
export function Header({ icon, title, subtitle, chip }: Props) {
    return (
        <header className={css.header}>
            <span className={css.icon}>{icon}</span>
            <div className={css.text}>
                <p className={css.title}>{title}</p>
                <p className={css.subtitle}>{subtitle}</p>
            </div>

            <span className={css.chip}>{chip}</span>
        </header>
    );
}
